import React from 'react';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import * as PropTypes from 'prop-types';

import classes from './index.module.css';

const ToolTip = dynamic(() => import('components/toolTip'));

const SalaryChartTooltip = ({ majorVersion }) => {
  return (
    <div
      className={classNames(classes.salaryChartTooltip, { [classes.majorVersion]: majorVersion })}
    >
      <ToolTip>
        To create our salary estimates, Zippia starts with data published in publicly available
        sources such as the U.S. Bureau of Labor Statistics (BLS), Foreign Labor Certification Data
        Center (FLC){' '}
        <a href="/salary-methodology/" target="_blank">
          Show More
        </a>
      </ToolTip>
    </div>
  );
};

SalaryChartTooltip.propTypes = {
  majorVersion: PropTypes.bool,
};

SalaryChartTooltip.defaultProps = {
  majorVersion: false,
};

export default SalaryChartTooltip;
